import { LicensePackageTypes } from './license';

export interface IProduct {
    ID: number;
    Name: string;
    PriceMonthly: number;
    PriceYearly: number;
    SetupMonthly: number;
    SetupYearly: number;
    PackageType: LicensePackageTypes;
    ProductID: number;
    YardAddon: IProduct;

    TaxRate: number;
    TaxRateDisplay: string;
    SubTotalMonthlyWithSetup: number;
    SubTotalYearlyWithSetup: number;
    TotalTaxMonthly: number;
    TotalTaxYearly: number;
    TotalTaxMonthlyNoSetup: number;
    TotalTaxYearlyNoSetup: number;
    TotalMonthlyNoSetup: number;
    TotalYearlyNoSetup: number;

    TotalMonthly: number;
    TotalYearly: number;

}

export class ProductArray extends Array<Product> {

    constructor(...items: Product[]) {
        super(...items);
        Object.setPrototypeOf(this, ProductArray.prototype);
    }


}

export class Product implements IProduct {
    ID: number;
    Name: string;
    PriceMonthly: number;
    PriceYearly: number;
    SetupMonthly: number;
    SetupYearly: number;
    PackageType: LicensePackageTypes;
    ProductID: number;
    YardAddon: Product;

    TaxRate: number;
    TaxRateDisplay: string;
    SubTotalMonthlyWithSetup: number;
    SubTotalYearlyWithSetup: number;
    TotalTaxMonthly: number;
    TotalTaxYearly: number;
    TotalTaxMonthlyNoSetup: number;
    TotalTaxYearlyNoSetup: number;
    TotalMonthlyNoSetup: number;
    TotalYearlyNoSetup: number;
    
    TotalMonthly: number;
    TotalYearly: number;    
}
